import { render } from "./ExtrachargeForm.vue?vue&type=template&id=0217de14"
import script from "./ExtrachargeForm.vue?vue&type=script&lang=js"
export * from "./ExtrachargeForm.vue?vue&type=script&lang=js"

import "./ExtrachargeForm.vue?vue&type=style&index=0&id=0217de14&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__